module.exports = __webpack_public_path__ + "img/quote-start.796d281.png";